/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { useLazyQuery } from '@apollo/client';
import { GET_IDEA_SUGGESTION, SuggestionResult } from '@frontend/data-access';
import { ChallengeCardSuggestion } from '@frontend/feature-intrapreneur-challenge';
import { Button, Col, Pagination, Row, Spin } from 'antd';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import styles from './idea-suggestion-list.module.less';
import useTranslation from 'next-translate/useTranslation';

/* eslint-disable-next-line */
export interface IdeaSuggestionListProps {}

export function IdeaSuggestionList(props: IdeaSuggestionListProps) {
  const { t } = useTranslation('common');
  const router = useRouter();
  const id = router.query['id'];

  const [currentPage, setCurrentPage] = useState(1);
  const LIMIT = 4;

  const [getSuggestedChallenges, { data: suggestedChallenges, loading }] =
    useLazyQuery<{
      listSuggestionResults: {
        candidateResponses: SuggestionResult[];
        total: number;
      };
    }>(GET_IDEA_SUGGESTION, {
      fetchPolicy: 'network-only',
    });

  useEffect(() => {
    if (id) {
      getSuggestedChallenges({
        variables: { id: id, limit: LIMIT, page: 1, type: 'IDEA' },
      });
      setCurrentPage(1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    getSuggestedChallenges({
      variables: { id: id, limit: LIMIT, page: page, type: 'IDEA' },
    });
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[200px]">
        <Row justify="center">
          <Spin />
        </Row>
      </div>
    );
  }
  if (
    !suggestedChallenges?.listSuggestionResults ||
    suggestedChallenges?.listSuggestionResults.total === 0
  ) {
    return (
      <div className="flex items-center justify-center min-h-[200px]">
        <div className="flex flex-col items-center gap-4">
          <div>{t('finding_challenges')}</div>
          <span>{t('notify_complete')}</span>
          <Button
            type="primary"
            shape="round"
            onClick={() => {
              getSuggestedChallenges({
                variables: { id: id, limit: LIMIT, page: 1, type: 'IDEA' },
              });
              setCurrentPage(1);
            }}
          >
            {t('refresh')}
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className={styles['container']}>
      {suggestedChallenges?.listSuggestionResults &&
        suggestedChallenges.listSuggestionResults.total > 0 && (
          <div className="space-y-6">
            <Row gutter={[24, 24]}>
              {suggestedChallenges.listSuggestionResults.candidateResponses.map(
                (result) => (
                  <Col key={result.internalChallenge?.id} xs={24} md={12}>
                    <ChallengeCardSuggestion
                      result={result}
                      className="!px-3 !py-4"
                    />
                  </Col>
                )
              )}
            </Row>
            <Pagination
              current={currentPage}
              pageSize={LIMIT}
              total={suggestedChallenges?.listSuggestionResults.total || 0}
              onChange={handlePageChange}
              showSizeChanger={false}
            />
          </div>
        )}
    </div>
  );
}

export default IdeaSuggestionList;
